import { StoppedPaymentsActionTypes } from "models/actionTypes/stoppedPaymentsActionTypes";
import { ReduxConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

export const stoppedPaymentsReportUpdated = (
  stoppedPayments: WintSuperkollAPIModel.StoppedPayments
): StoppedPaymentsActionTypes => {
  return {
    type: ReduxConstants.StoppedPaymentsActions.STOPPED_PAYMENTS_REPORT_UPDATED,
    payload: stoppedPayments,
  };
};

export const stoppedPaymentsReportCompleted = (id: number): StoppedPaymentsActionTypes => {
  return {
    type: ReduxConstants.StoppedPaymentsActions.STOPPED_PAYMENTS_REPORT_COMPLETED,
    payload: id,
  };
};
